// TimeMessage component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import AddButton from '../../../common/common/add_button/add_button.jsx'
import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'

class TimeMessage extends Component {
  static get propTypes () {
    return {
      message: PropTypes.string,
      onAdd: PropTypes.func,
      onStart: PropTypes.func,
      className: PropTypes.string,
      ignoreTimer: PropTypes.bool,
      ignoreLine: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      message: '',
      onAdd: null,
      onStart: null,
      className: '',
      ignoreTimer: false,
      ignoreLine: false
    }
  }

  render () {
    const { message, ignoreTimer, ignoreLine } = this.props
    const classes = classnames('time-message', {}, this.props.className)
    const splitterClass = classnames('splitter', {
      splitter_ignore: ignoreTimer,
      splitter_ignoreline: ignoreLine
    })

    return (
      <div className={classes}>
        <h2 className='message'>
          <IntlMessage ident={message} />
        </h2>
        {!ignoreTimer && (
          <div className='info'>
            <p className='info'>
              <IntlMessage ident='time.form.clickText' />
              &nbsp;
              <i className='icon icon-time-add normal' />
              {!ignoreTimer ? (
                <IntlMessage ident='time.form.timeText' />
              ) : (
                <IntlMessage ident='time.form.timeTextAlt' />
              )}
              &nbsp;
              <i className='icon icon-time-track normal' />
              <IntlMessage ident='time.form.startText' />
            </p>
          </div>
        )}
        {ignoreTimer && (
          <div className='info'>
            <p className='info'>
              <IntlMessage ident='time.form.clickText' />
              &nbsp;
              <i className='icon icon-time-add normal' />
              <IntlMessage ident='time.form.timeTextAlt' />
            </p>
          </div>
        )}
        {!ignoreTimer && (
          <div className={splitterClass}>
            <AddButton onClick={this._onClickAdd.bind(this)} />
            <IconButton
              icon='time-starttimer'
              canHover={false}
              className='addtimerbutton'
              size='big'
              onClick={this._onClickStart.bind(this)}
            />
          </div>
        )}
        {ignoreTimer && (
          <div className={splitterClass}>
            <AddButton onClick={this._onClickAdd.bind(this)} />
          </div>
        )}
      </div>
    )
  }

  /* Event handlers */
  _onClickAdd (e) {
    e.preventDefault()

    if (this.props.onAdd) {
      this.props.onAdd(e)
    }
  }

  _onClickStart (e) {
    e.preventDefault()

    if (this.props.onStart) {
      this.props.onStart(e)
    }
  }
}

export default TimeMessage
